// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__yRN+T","text":"CookieBanner_text__kyKRP"};